import { createFileRoute } from '@tanstack/react-router';
import OurDossiers from '../../../features/dossiers/list/ourDossiers';
import {
  createPermissionGuard,
  DOSSIER_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/vorgaenge/(listen)/unsere')({
  component: OurDossiers,
  beforeLoad: createPermissionGuard(
    getPermissionSet(DOSSIER_PERMISSIONS, 'READ'),
  ),
});

export const ListOurDossiersRoute = Route;
